export default class AppSidebar {
    constructor () {
        this.$body = $('body');

        let self = this;
        $('#toggle-sidebar').on('click', function () {
            self.toggleSidebar();
        });

        this.initMobileMenu();
    }

    toggleSidebar () {
        if (this.isMini()) {
            this.$body.removeClass('sidebar-mini');
        } else {
            this.$body.addClass('sidebar-mini');
        }

        $(window).trigger('resize');
    }

    isMini () {
        return this.$body.hasClass('sidebar-mini');
    }

    isMobileNavOpen () {
        return this.$body.hasClass('nav-open');
    }

    initMobileMenu () {
        let $toggle = $('.navbar-toggler');

        let self = this;
        $toggle.on('click', function () {
            if (self.isMobileNavOpen()) {
                self.$body.removeClass('nav-open');

                $('.close-layer').remove();

                $toggle.removeClass('toggled');
            } else {
                $toggle.addClass('toggled');

                let mainPanelHeight = $('.main-panel')[0].scrollHeight;
                let $layer = $('<div class="close-layer visible"></div>');
                $layer.css('height', mainPanelHeight + 'px');
                $layer.appendTo('.main-panel');

                $layer.on('click', function () {
                    self.$body.removeClass('nav-open');
                    $layer.remove();
                    $toggle.removeClass('toggled');
                });

                self.$body.addClass('nav-open');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/sidebar.js